(function (root) {
  'use strict';
  const types = ['cover-and-wallet-cases','holsters','mounts-stands','armbands','phone-socks','waterproof-bag'];
  const validType = value => types.includes(value) ? value : '';
  const typeFromHash = hash => validType(new URLSearchParams(String(hash || '').replace(/^#/, '')).get('dfv-type'));
  function withTypeUrl(href, type, origin) {
    if (!validType(type)) return href;
    const url = new URL(href, origin);
    if (url.origin !== origin) return href;
    const match = url.pathname.match(/^(\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections\/[^/]+)(?:\/([^/]+))?\/?$/i);
    if (!match || (match[2] && !validType(match[2]))) return href;
    url.pathname = match[1];
    url.searchParams.set('view', 'dfv-cro-' + type);
    return url.pathname + url.search + url.hash;
  }
  const api = {types, validType, typeFromHash, withTypeUrl};
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (!root || !root.document) return;
  const document = root.document;
  function currentType() {
    return typeFromHash(root.location.hash) || validType(new URLSearchParams(root.location.search).get('view')?.replace(/^dfv-cro-/, '')) || validType(root.location.pathname.split('/').filter(Boolean).pop());
  }
  api.currentType = currentType;
  root.DFVCro = api;
  function syncContext() {
    const active = currentType();
    document.documentElement.dataset.dfvCroActiveType = active;
    document.querySelectorAll('[data-dfv-type-context]').forEach(section => {
      section.querySelectorAll('[data-dfv-type]').forEach(link => {
        const selected = (link.dataset.dfvType || '') === active;
        link.setAttribute('aria-current', selected ? 'true' : 'false');
        if (selected && active) {
          const label = section.querySelector('[data-dfv-type-label]');
          if (label) { label.textContent = link.textContent.trim(); label.hidden = false; }
        }
      });
      const details = section.querySelector('details');
      if (details && active) details.open = true;
      const label = section.querySelector('[data-dfv-type-label]');
      if (label && !active) label.hidden = true;
    });
    document.querySelectorAll('a[data-dfv-brand-cta]').forEach(link => {
      const url = new URL(link.href);
      const hash = new URLSearchParams(url.hash.slice(1));
      if (active) hash.set('dfv-type', active); else hash.delete('dfv-type');
      url.hash = hash.toString(); link.href = url.pathname + url.search + url.hash;
    });
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('a');
    if (!link) return;
    const active = currentType();
    if (!active) return;
    if (link.matches('a.dfv-finder__suggestion--model,a[data-dfv-device-collection]') || link.closest('[data-results],.dfv-bm-priority-links')) {
      link.href = withTypeUrl(link.getAttribute('href'), active, root.location.origin);
    }
  }, true);
  document.addEventListener('submit', event => {
    if (currentType() && event.target.closest('dfv-device-search,[data-brand-form]')) event.preventDefault();
  }, true);
  root.addEventListener('hashchange', syncContext);
  const init = () => {
    syncContext();
    const brand = new URLSearchParams(root.location.hash.slice(1)).get('brand');
    if (brand) Array.from(document.querySelectorAll('button[data-brand]')).find(button => button.dataset.brand === brand)?.click();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
})(typeof window === 'undefined' ? null : window);
